import { useEffect, useRef, useState } from "react";
import { useHistory } from "react-router";

import { IModal } from "../types/modal";
import { useModal } from "./useModal";

interface HandleLeavePromptProperties extends IModal {
  handleContinue: () => void;
}

export const useHandleLeavePrompt = (when: boolean, ignoredIds?: string[]): HandleLeavePromptProperties => {
  const [targetPathname, setTargetPathname] = useState<string>("");
  const { isModalVisible, toggleModalVisibility: toggle } = useModal();
  const history = useHistory();
  const unblockRef = useRef<any>(null);

  const handleRouteChangeClick = (e: MouseEvent) => {
    const isIgnoredById =
      ignoredIds &&
      ignoredIds.find((id) => {
        const el = document.getElementById(id as string);
        return el && el.contains(e.target as Node);
      });

    if (isIgnoredById) {
      unblockRef.current = history.block(() => {
        return;
      });
      return;
    }

    unblockRef.current = history.block((location) => {
      if (when) {
        setTargetPathname(location.pathname);
        toggle();
        return false;
      }
      return;
    });
  };

  useEffect(() => {
    document.addEventListener("click", handleRouteChangeClick, true);
    return () => {
      document.removeEventListener("click", handleRouteChangeClick, true);
    };
  }, [unblockRef, history, ignoredIds]);

  const handleContinue = (): void => {
    if (unblockRef && unblockRef.current) {
      unblockRef.current();
    }
    toggle();
    history.push(targetPathname);
  };

  const toggleModalVisibility = () => {
    unblockRef.current = history.block(() => {
      return;
    });
    toggle();
  };

  return {
    isModalVisible,
    toggleModalVisibility,
    handleContinue,
  };
};
